import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          deletion: {
            '{}': {
              ids: {
                '[]': [
                  {
                    '@$': 'subrecipientId',
                  },
                ],
              },
              modelId: 'ent:!subrecips:!subrecip',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
